import { IAddressModel } from "../models/address/address.model";
import { IAddressDtoModel } from "../models/address/dto/address-dto.model";
import { IModelMapping } from "./generic/model.mapping";
import { ISavedAddressModel } from "../models/saved-address/saved-address.model";
import { IJControlAddressDtoModel, IJControlAddressMessageDtoModel } from "../models/saved-address/dto/jcontrol-address-message-dto.model";
import { ICustomerCreateModel } from "../models/customer/customer-create.model";
export class AddressMapping implements IModelMapping<IAddressDtoModel, IAddressModel> {

    toApplicationModel(model: IAddressDtoModel): IAddressModel {
        return {
            ...model
        } as IAddressModel
    }

    toDtoModel(model: IAddressModel): IAddressDtoModel {
        return {
            ...model
        } as IAddressDtoModel
    }

    toDtoModels(models: IAddressModel[]): IAddressDtoModel[] {
        return models.map(m => this.toDtoModel(m));
    }

    toApplicationModels(models: IAddressDtoModel[]): IAddressModel[] {
        return models.map(m => this.toApplicationModel(m));
    }

    toApplicationModelFromString(addressDetailsResponse: string): IAddressModel {

      let foundAddress = JSON.parse(addressDetailsResponse);
      let address = {
        addressLine1: foundAddress.DeliveryAddress1 ? foundAddress.DeliveryAddress1 : foundAddress.Address1,
        townCity: foundAddress.Locality,
        countyState: foundAddress.AdministrativeArea,
        postalCode: foundAddress.PostalCode,
        countryName: foundAddress.CountryName,
        countryCode: foundAddress['ISO3166-2']

      } as IAddressModel;

      if (address.countryCode == 'GR') {
        address.countryCode = 'EL';
      }

      if(foundAddress.DeliveryAddress2 != foundAddress.Locality){
        address.addressLine2 = foundAddress.DeliveryAddress2;
      } 

      return address;

    }

    toJControlAddressMessageModel(type: string, addressType: string, model: ISavedAddressModel, companyName?: string, saveNewAddress?: boolean): IJControlAddressMessageDtoModel {
      return {
        messageType: type,
        type: addressType,
        customerAddress: this.toJControlAddressModel(model),
        companyName: companyName,
        saveNewAddress: saveNewAddress
      } as IJControlAddressMessageDtoModel
    }

    toJControlAddressModel(model: ISavedAddressModel | undefined): IJControlAddressDtoModel | undefined {
      
      if(!model || !model.details){
        return undefined;
      }

      return {
          id: model.id,
          contactName: model.details.name,
          addressLine1: model.details.addressLine1,
          addressLine2: model.details.addressLine2,
          townCity: model.details.townCity,
          countyState: model.details.countyState,
          postalCode: model.details.postalCode,
          countryName: model.details.countryName,
          country_Code: model.details.countryCode,
          isVerified: model.details.isVerified,
          contactTelephone: model.details.contactNumber
      } as IJControlAddressDtoModel;
    }

    toJControlNewCustomerAddressModel(model: ICustomerCreateModel): IJControlAddressDtoModel {
      console.log(model);
      return {
          contactName: model.companyName ? model.companyName : (model.firstName + " " + model.lastName),
          addressLine1: model.addressLine1,
          addressLine2: model.addressLine2,
          townCity: model.townCity,
          countyState: model.countyState,
          postalCode: model.postalCode,
          countryName: model.countryName,
          country_Code: model.countryCode,
          isVerified: model.isVerified,
          contactTelephone: model.mobileNumber ? model.mobileNumber : (model.telephoneNumber ? model.telephoneNumber : undefined)
      } as IJControlAddressDtoModel;
    }
}